import { render } from "./FeaturesView.vue?vue&type=template&id=08a9630e"
const script = {}

import "./FeaturesView.vue?vue&type=style&index=0&id=08a9630e&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__